if (!customElements.get('ladf-slider')) {
  customElements.define('ladf-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) this.cleanup();
      const track = this.querySelector('[data-track]');
      const dots = this.querySelector('[data-dots]');
      if (!track || !dots) return;
      dots.replaceChildren();
      const cards = [...track.children];
      const buttons = cards.map((card, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', `Show card ${index + 1}`);
        button.addEventListener('click', () => track.scrollTo({left: card.offsetLeft - cards[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}));
        dots.append(button);
        return button;
      });
      let frame;
      const update = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          let active = 0;
          cards.forEach((card, index) => { if (Math.abs(card.offsetLeft - cards[0].offsetLeft - track.scrollLeft) < Math.abs(cards[active].offsetLeft - cards[0].offsetLeft - track.scrollLeft)) active = index; });
          buttons.forEach((button,index) => button.setAttribute('aria-current', String(index === active)));
        });
      };
      track.addEventListener('scroll', update, {passive:true});
      const resize = new ResizeObserver(update);
      resize.observe(track);
      update();
      this.cleanup = () => { cancelAnimationFrame(frame); track.removeEventListener('scroll',update); resize.disconnect(); };
    }
    disconnectedCallback() { this.cleanup?.(); }
  });
}
